import React, { Component } from "react";
import axios from "axios";
import Navbar from "../../Navbar";
import Message from "../../../utilityComponents/Message";
import userAvatar from "../../../images/user-avatar.png";
import "../css/Profile.css";

class Profile extends Component {
    constructor() {
        super();
        this.state = {
            userInfo: {},
        };
        this.msgDefVal = {
            success: "",
            inputError: "",
            error: "",
        };
    }
    componentWillMount() {
        axios
            .get("/api/user/cp/wrt")
            .then((response) => {
                console.log(response);
                this.setState({
                    userInfo: response.data,
                });
                console.log(response);
            })
            .catch((error) => {
                console.log(error);
                // if(error.hasOwnProperty("response") && error.response.hasOwnProperty("data")
                //    && error.response.data.hasOwnProperty("message")){
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    const data = error.response.data;
                    console.log(data);
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            ...this.msgDefVal,
                            error: data.message,
                        };
                    });
                } else {
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            ...this.msgDefVal,
                            error: "Something Went Wrong, Please Try Again!!",
                        };
                    });
                }
            });
    }
    _getCPUrl() {
        let params = {
            token: this.state.userInfo.token,
        };
        let query = this.encodeQueryData(params);
        let cpUrl = "/reset-password/";
        return cpUrl + "?" + query;
    }
    encodeQueryData(data) {
        const ret = [];
        for (let d in data) {
            ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
        }
        return ret.join("&");
    }
    render() {
        let render_template = null;
        let auth_reset_request = this._getCPUrl();
        render_template = (
            <>
                <Navbar />
                <div className="page-heading">
                    <h1 className="page-title">My Profile</h1>
                </div>
                <div className="page-content fade-in-up">
                    <div className="row">
                        <div className="col-12">
                            {this.state.error && (
                                <Message variant="danger">{this.state.error}</Message>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-5" style={{ margin: "auto" }}>
                            <div className="card cus-card-margin">
                                <div
                                    className="card-body text-center"
                                    style={{ "box-shadow": "8px 8px 8px #bfbfbf" }}
                                >
                                    <div className="m-t-20">
                                        <img
                                            className="img-circle"
                                            src={userAvatar}
                                            style={{ "box-shadow": "8px 8px 8px #bfbfbf" }}
                                        ></img>
                                    </div>
                                    <h5 className="font-strong m-b-10 m-t-10">
                                        {this.state.userInfo.full_name}
                                    </h5>
                                    <div className="m-b-20 text-muted">
                                        {this.state.userInfo.role_description}
                                    </div>
                                    <div>
                                        <a
                                            className="btn btn-outline-info m-b-5"
                                            href={auth_reset_request}
                                        >
                                            Change Password
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="card cus-card-margin">
                                <div
                                    className="card-body cus-text-align-end"
                                    style={{
                                        "padding-top": "20px",
                                        "box-shadow": "8px 8px 8px #bfbfbf",
                                    }}
                                >
                                    <div className="row">
                                        <div className="col-sm-5 m-b-10">
                                            <b>Username: </b>
                                        </div>
                                        <div className="col-sm-7" style={{ "text-align": "left" }}>
                                            {this.state.userInfo.username}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-5 m-b-10">
                                            <b>Email ID: </b>
                                        </div>
                                        <div className="col-sm-7" style={{ "text-align": "left" }}>
                                            {this.state.userInfo.email_id}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-5 m-b-10">
                                            <b>Employee ID: </b>
                                        </div>
                                        <div className="col-sm-7" style={{ "text-align": "left" }}>
                                            {this.state.userInfo.emp_id}
                                        </div>
                                    </div>
                                    <div className="row ">
                                        <div className="col-sm-5 m-b-10">
                                            <b>Contact No: </b>
                                        </div>
                                        <div className="col-sm-7" style={{ "text-align": "left" }}>
                                            {this.state.userInfo.contact}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
        return render_template;
    }
}

export default Profile;
